// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  infoContainer: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    margin: '0 40px',
    [theme.breakpoints.down(450)]: {
      maxWidth: 200,
    }
  },
  subText: {
    textAlign: 'justify',
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_BLACK_GREY,
    [theme.breakpoints.down(450)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    },
    padding: '10px 0',
  },
});

export default styles;
